// Polyfills
import './utils/polyfill-nodelist-foreach';

// jQuery
import './utils/jquery';
import $ from 'jquery';
import $script from 'scriptjs';

// Shared Components
import ShopifySectionsManager from 'shopify-sections-manager';
import 'intersection-observer/intersection-observer';
import rimg from 'rimg-shopify';
import PxsMap from 'pxs-map';

// Utils
import Rte from './utils/Rte';
import ThemeUtils from './utils/ThemeUtils';

// Templates
import TemplateAccount from './templates/TemplateAccount';
import TemplateCollection from './templates/TemplateCollection';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplatePassword from './templates/TemplatePassword';

// Sections
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicVideo from './sections/DynamicVideo';
import StaticCart from './sections/StaticCart';
import StaticProduct from './sections/StaticProduct';
import StaticProductRecommendations from './sections/StaticProductRecommendations';

// Components
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';

const scripts = $('[data-scripts]');

class Pacific {
  constructor() {
    window.ThemeUtils = ThemeUtils;
    this.$el = $(document.body);
    this.render();
  }

  render() {
    // Common views
    this.sections = new ShopifySectionsManager();

    this.sections.register('header', section => new Header(section));
    this.sections.register('footer', section => new Footer(section));
    this.sections.register('slideshow', section => new DynamicSlideshow(section));
    this.sections.register('featured-video', section => new DynamicVideo(section));
    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('featured-product', section => new StaticProduct(section));
    this.sections.register('page-product', section => new StaticProduct(section));
    this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
    this.sections.register('page-collection', section => new TemplateCollection(section));
    this.sections.register('page-cart', section => new StaticCart(section));
    this.sections.register('pxs-announcement-bar', section => new AnnouncementBar(section));

    $('.rte').each((index, rte) => { this.rte = new Rte({ el: rte }); });

    if (window.Pacific.settings['enable-sidebar']) { this.sidebar = new Sidebar({ el: $('.sidebar') }); }

    // Conditional views
    if (this.$el.attr('class').indexOf('-customers-') > 0) {
      this.templateAccount = new TemplateAccount({ el: this.$el });
    }
    if (this.$el.hasClass('template-password')) {
      this.templatePassword = new TemplatePassword({ el: this.$el });
    }
    if (this.$el.hasClass('gift-card-template')) {
      this.templateGiftCard = new TemplateGiftCard();
    }

    rimg.init();
  }
}

$script([
  scripts.data('countries-url'),
  scripts.data('customer-area-url'),
  scripts.data('shopify-api-url'),
  scripts.data('jquery-templates-url'),
  scripts.data('shopify-common-url'),
],
() => {
  $script([
    scripts.data('jquery-cart-url'),
  ],
  () => {
    window.Pacific.theme = new Pacific();
  });
});
